module.exports = __webpack_public_path__ + "static/media/amulet_05.67a48278.png";